import React from 'react';
import styles from './ProfileStep.module.css';

const ProfileStep = ({
  firstName, setFirstName,
  middleName, setMiddleName,
  lastName, setLastName,
  companyName, setCompanyName,
  phoneNumber, setPhoneNumber,
  error, onNext,
}) => {
  return (
    <div className={styles.box}>
      <div className={styles.layout}>
        <button type="button" className={styles.goBackBtn} aria-hidden="true" tabIndex={-1}>
          <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.28809 0.358398L0.348633 7.5L7.28809 14.6426L8.65234 13.2373L3.25781 7.67383L3.08887 7.5L3.25781 7.32617L8.65234 1.76367L7.28809 0.358398Z" fill="black" fillOpacity="0.6" stroke="white" strokeWidth="0.5"/>
          </svg>
          Go back
        </button>

        <div className={styles.topSection}>
          <div className={styles.mainTitle}>Set up your profile</div>
          <div className={styles.subtitle}>
            We just need a few details to get your account up and running.
          </div>
          <div className={styles.progressBar}>
            <div className={styles.progressBarBg} />
            <div className={styles.progressBarFill} />
          </div>
        </div>

        <div className={styles.contentRow}>
          <div className={styles.formSection}>
            <div className={styles.nameRow}>
              <div className={styles.field}>
                <label className={styles.label}>First Name</label>
                <input className={styles.input} type="text" placeholder="Enter your Name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Middle Name (Optional)</label>
                <input className={styles.input} type="text" placeholder="Enter your Middle Name" value={middleName} onChange={(e) => setMiddleName(e.target.value)} />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Last Name</label>
                <input className={styles.input} type="text" placeholder="Enter your Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
              </div>
            </div>

            <div className={styles.twoColRow}>
              <div className={styles.field}>
                <label className={styles.label}>Company Name</label>
                <input className={styles.input} type="text" placeholder="Enter your Name" value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Phone Number</label>
                <input className={styles.input} type="tel" placeholder="Enter your Middle Name" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} maxLength="10" />
              </div>
            </div>

            {onNext && (
              <button type="button" className={styles.nextBtn} onClick={onNext}>
                Next
              </button>
            )}

            {error && <div className={styles.error}>{error}</div>}
          </div>

          <div className={styles.peekSection} aria-hidden="true">
            <div className={styles.peekTitle}>How do you primarily build your brand on Amazon?</div>
            <div className={styles.peekChips}>
              {['Private Label', 'Wholesale/Resell', 'Traders', 'Dropshipping', 'KDP/Publishing'].map((opt) => (
                <span key={opt} className={styles.peekChip}>{opt}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileStep;
